



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmationActionButton extends Vue {
  @Prop({ required: true })
  public iconCode: string;
  @Prop({ required: true })
  public buttonText: string;
  @Prop({ required: true })
  public confirmationText: string;

  public open = false;

  public mounted() {
    document.body.addEventListener('click', this.hideDialog);
  }

  public unmount() {
    document.body.removeEventListener('click', this.hideDialog);
  }

  public hideDialog() {
    this.open = false;
  }
}
